module.exports = __webpack_public_path__ + "static/img/xsdc1.72a2787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xsdc1.png
// module id = 3W6X
// module chunks = 1